import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { breakpoints } from '../../utils/styles';
import Button from '../Button';
import FieldRow from '../FieldRow';
import { openPopup } from '../../actions/creators/auth/apple';
import { facebookLogin } from '../../actions/creators/auth';
import { USER_DELETE_ACCOUNT_FB_LOGIN_COMPLETED } from '../../actions/types';

const PanelContainer = styled.div`
  @media screen and (min-width: ${breakpoints.desktop}px) {
    max-width: 70%;
  }
`;

interface Props {
    processing?: boolean;
    appleLogin: (callback: (result: any) => void) => void;
    facebookLogin: (callback: (result: any) => void, options?: any) => void;
    onFacebookLoginCompleted: () => void;
    onSubmit: (params: {password: string, sso?: {service: string, data: any}}) => void;
}

interface State {
    password: string;
    confirm: boolean;
    sso: {service: string, data: any} | null;
}

interface SubmitData {
    password: string;
    sso?: {
        service: string;
        data: any;
    };
}

class UserDeleteAccount extends React.Component<Props> {
    state: State;

    constructor(props) {
        super(props);

        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onConfirmChange = this.onConfirmChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.appleLogin = this.appleLogin.bind(this);
        this.facebookLogin = this.facebookLogin.bind(this);

        this.state = {
            password: '',
            confirm: false,
            sso: null,
        };
    }

    onPasswordChange(e) {
        const password = e.target.value;
        this.setState(() => ({ password }));
    }

    onConfirmChange(e) {
        const confirm = e.target.checked;
        this.setState(() => ({ confirm }));
    }

    onSubmit(e) {
        e.preventDefault();

        const params: SubmitData = {
            password: this.state.password
        };
        
        if (this.state.sso) {
            params.sso = {
                service: this.state.sso.service,
                data: this.state.sso.data,
            };
        }

        this.props.onSubmit(params);
    }

    appleLogin() {
        this.props.appleLogin(result => {
            if (result) {
                this.setState({
                    password: '',
                    sso: {
                        service: 'apple',
                        data: result
                    }
                });
            }
        });
    }

    facebookLogin() {
        this.props.facebookLogin(result => {
            if (result) {
                this.setState({
                    password: '',
                    sso: {
                        service: 'facebook',
                        data: result
                    }
                });
                this.props.onFacebookLoginCompleted();
            }
        }, {auth_type: 'reauthenticate'});
    }

    render() {
        return (
            <div>
                <PanelContainer>
                    <h1 className="c-entry__title">
                        Eliminar cuenta
                    </h1>
                    <p>
                        Estás a punto de eliminar tu cuenta. Esta acción no puede deshacerse.
                    </p>
                    <div>
                        <form onSubmit={this.onSubmit}>
                            {!this.state.sso && (
                                <React.Fragment>
                                    <div className="mb-3">
                                        <FieldRow type="password" label="Para continuar ingresa tu contraseña:" autoFocus required
                                            value={this.state.password} onChange={this.onPasswordChange} disabled={this.props.processing}
                                        />
                                    </div>
                                    <p className="text-center mb-3">
                                        <small className="d-block text-secondary">O ingresa con tu cuenta de Facebook o Apple</small>
                                    </p>
                                    <div className="row">
                                        <div className="col-6">
                                            <Button onClick={this.facebookLogin} block smallPadding facebook className=" mb-2"><i className="fab fa-facebook-f"></i></Button>
                                        </div>
                                        <div className="col-6">
                                            <Button onClick={this.appleLogin} block smallPadding className=" mb-2"><i className="fab fa-apple"></i></Button>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            <div className="text-center form-group my-5">
                                <input type="checkbox" onChange={this.onConfirmChange} />&nbsp; Confirmo que deseo eliminar mi cuenta.
                            </div>
                            <Button submit primary large block disabled={!this.state.confirm || (!this.state.password && !this.state.sso) || this.props.processing}>Eliminar cuenta</Button>
                        </form>
                    </div>

                </PanelContainer>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    appleLogin: callback => dispatch(openPopup(callback)),
    facebookLogin: (callback, options) => dispatch(facebookLogin(callback, options)),
    onFacebookLoginCompleted: () => dispatch({ type: USER_DELETE_ACCOUNT_FB_LOGIN_COMPLETED }),
});

export default connect(
    null,
    mapDispatchToProps
)(UserDeleteAccount);